// Ταξινόμηση προϊόντων για την αρχική σελίδα:
// 1) Πρώτα τα ΑΜΕΣΑ ΔΙΑΘΕΣΙΜΑ (μετά τα υπόλοιπα διαθέσιμα, τέλος κατόπιν παραγγελίας)
// 2) Μετά με περισσότερες πωλήσεις (units_sold ↓)
// 3) Τέλος όσα έχουν φωτογραφία πριν από όσα δεν έχουν

export type SortableProduct = {
  availability?: string | null;
  stock_quantity?: number | null;
  units_sold?: number | null;
  image_url?: string | null;
};

function availabilityRank(p: SortableProduct): number {
  const a = (p.availability ?? "").toLowerCase();
  const stock = Number(p.stock_quantity ?? 0);
  if (a.includes("άμεσα")) return 0;
  if (stock > 0 || a.includes("διαθέσιμ")) return 1;
  return 2;
}

export function sortHomeProducts<T extends SortableProduct>(products: T[]): T[] {
  return [...products].sort((a, b) => {
    const ra = availabilityRank(a);
    const rb = availabilityRank(b);
    if (ra !== rb) return ra - rb;

    const sa = Number(a.units_sold ?? 0);
    const sb = Number(b.units_sold ?? 0);
    if (sa !== sb) return sb - sa;

    const ia = a.image_url ? 0 : 1;
    const ib = b.image_url ? 0 : 1;
    return ia - ib;
  });
}
